/*
  CB 15-16/10/2026 - aiuti per scheda prodotto e barra EGO.
  1) Barra traguardi EGO (scheda prodotto e /cart): soglia sotto ogni traguardo.
  2) Sconto quantita' Vitals: larghezza del widget -> --cb-vd-w su block-buy-buttons.
  3) Sconto quantita' Vitals e selettore Quantita' (Vitals all'aggiunta usa SEMPRE
     la quantita' dell'opzione del widget):
     - quantita' 1-3 dal selettore -> il widget passa all'opzione N (in ordine);
     - da 4 in su il clic su "Aggiungi al carrello" - sia nella scheda sia nella barra
       fissa di Vitals in fondo alla pagina (#bundle-sticky_add_to_cart) - e' gestito
       qui: aggiunge la quantita' esatta del selettore e apre il carrello laterale.
       Il controllo e' registrato in testa alla pagina (layout/theme.liquid) per
       arrivare prima di Vitals.
  4) Riga Formato + Quantita' (div.cb-opt-row): dal 16/10 la crea il tema
     (sections/main-product.liquid), senza spostamenti al caricamento. Qui resta solo
     una riserva per template che non la creano.
*/
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/')

  // ---- 1) soglie EGO ---------------------------------------------------------
  function milestones() {
    var S = window.EgoFreeGiftSettings
    var list = S && S.settings && S.settings.active_campaigns
    if (!list) return null
    for (var i = 0; i < list.length; i++) {
      var g = list[i].giftMilestoneSetting
      if (g && g.milestones && g.milestones.length && (!g.tieredRewardType || g.tieredRewardType === 'total_cart_value')) {
        return g.milestones.slice().sort(function (a, b) { return a.buyAtLeast - b.buyAtLeast })
      }
    }
    return null
  }
  function label(amount) {
    var S = window.EgoFreeGiftSettings || {}
    var fmt = S.money_format || '€{{amount_with_comma_separator}}'
    var cents = Math.round(amount * 100)
    var parts = (cents / 100).toFixed(2).split('.')
    var dec = cents % 100 === 0
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? '' : ',' + parts[1])
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (dec ? '' : '.' + parts[1])
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, dot)
  }
  function egoThresholds() {
    var ms = milestones()
    if (!ms) return
    var bars = document.querySelectorAll('.ego-milestone-bar')
    for (var b = 0; b < bars.length; b++) {
      var items = bars[b].querySelectorAll('.ego-layout1-milestone')
      if (items.length !== ms.length) continue
      for (var i = 0; i < items.length; i++) {
        var text = label(ms[i].buyAtLeast)
        var thr = items[i].querySelector(':scope > .cb-ego-thr')
        if (!thr) {
          thr = document.createElement('span')
          thr.className = 'cb-ego-thr'
          var circle = items[i].querySelector(':scope > .ego-layout1-milestone-circle')
          if (circle && circle.nextSibling) items[i].insertBefore(thr, circle.nextSibling)
          else items[i].appendChild(thr)
        }
        if (thr.textContent !== text) thr.textContent = text
      }
    }
  }

  // ---- 2) larghezza widget sconto quantita' ------------------------------------
  function volumeWidth() {
    var blocks = document.querySelectorAll('#MainContent block-buy-buttons')
    for (var i = 0; i < blocks.length; i++) {
      var w = blocks[i].querySelector('.Vtl-NewVolumeDiscountRadio__TierList')
      var px = w ? Math.round(w.getBoundingClientRect().width) : 0
      var val = px > 0 ? px + 'px' : ''
      if (blocks[i].style.getPropertyValue('--cb-vd-w') !== val) {
        if (val) blocks[i].style.setProperty('--cb-vd-w', val)
        else blocks[i].style.removeProperty('--cb-vd-w')
      }
    }
  }

  // ---- 3) quantita' <-> widget sconto quantita' --------------------------------
  var STICKY_BTN = '#bundle-sticky_add_to_cart .Vtl-StickyAddToCart__Actions button'
  function buyBlock() { return document.querySelector('#MainContent block-buy-buttons') }
  function mainAtc() { return document.querySelector('#MainContent block-buy-buttons .add-to-cart') }
  function tiers() {
    var b = buyBlock()
    return b ? Array.prototype.slice.call(b.querySelectorAll('.Vtl-NewVolumeDiscountRadio__TierItem')) : []
  }
  function qtyInput() {
    return document.querySelector('#MainContent block-quantity-selector input[name="quantity"]') ||
      document.querySelector('#MainContent block-quantity-selector input')
  }
  function qtyValue() {
    var i = qtyInput()
    var n = i ? parseInt(i.value, 10) : 1
    return n > 0 ? n : 1
  }
  function syncTier() {
    var t = tiers()
    if (!t.length) return
    var q = qtyValue()
    if (q > t.length) return
    var li = t[q - 1]
    if (li.classList.contains('Vtl-NewVolumeDiscountRadio__TierItem--Selected')) return
    var radio = li.querySelector('[role="radio"]') || li.firstElementChild || li
    radio.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
    setTimeout(function () {
      var inp = qtyInput()
      if (inp && String(inp.value) !== String(q)) inp.value = q
    }, 120)
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#MainContent block-quantity-selector .element-quantity-selector__button')) {
      setTimeout(syncTier, 40)
    }
  }, true)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#MainContent block-quantity-selector')) syncTier()
  }, true)

  var adding = false
  function updateHeaderCount(c) {
    var nums = document.querySelectorAll('.cart-link__bubble-num')
    for (var i = 0; i < nums.length; i++) nums[i].textContent = c.item_count
    var bubbles = document.querySelectorAll('.cart-link__bubble')
    for (var j = 0; j < bubbles.length; j++) bubbles[j].classList.toggle('cart-link__bubble--visible', c.item_count > 0)
  }
  function showError(btn, msg) {
    var form = btn.closest('form')
    var p = form && form.parentElement.querySelector('.cb-atc-err')
    if (!p && form) {
      p = document.createElement('p')
      p.className = 'cb-atc-err'
      p.setAttribute('role', 'alert')
      p.style.cssText = 'margin:8px 0 0;color:#c41e3a;font-size:14px;line-height:1.4'
      form.insertAdjacentElement('afterend', p)
    }
    if (p) { p.textContent = msg; setTimeout(function () { p.textContent = '' }, 6000) }
  }
  // btn = pulsante della scheda (da cui si prende il modulo); clicked = pulsante premuto
  function addExact(btn, q, variantId, clicked) {
    if (adding) return
    adding = true
    var fd = new FormData(btn.closest('form'))
    fd.set('quantity', String(q))
    if (variantId) fd.set('id', String(variantId))
    var busy = [btn]
    if (clicked && clicked !== btn) busy.push(clicked)
    busy.forEach(function (b) { b.classList.add('btn--loading'); b.setAttribute('aria-busy', 'true') })
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j }) })
      .then(function () { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }) })
      .then(function (r) { return r.json() })
      .then(function (c) {
        updateHeaderCount(c)
        var d = window.vtlsCartDrawer
        if (d && typeof d.show === 'function') d.show()
        else window.location.href = ROOT + 'cart'
      })
      .catch(function (err) {
        showError(btn, (err && (err.description || err.message)) || 'Impossibile aggiungere al carrello, riprova.')
      })
      .then(function () {
        adding = false
        busy.forEach(function (b) { b.classList.remove('btn--loading'); b.removeAttribute('aria-busy') })
      })
  }
  // variante scelta nella barra fissa di Vitals (su mobile ha un menu formato)
  function stickyVariant(sticky) {
    var bar = sticky.closest('#bundle-sticky_add_to_cart')
    var sel = bar && bar.querySelector('select')
    return sel && /^\d+$/.test(sel.value) ? sel.value : null
  }
  window.cbVolumeIntercept = function (e) {
    var t = e.target
    if (!t || !t.closest) return
    var btn = null
    var sticky = null
    if (e.type === 'click') {
      btn = t.closest('#MainContent block-buy-buttons .add-to-cart')
      if (!btn) {
        sticky = t.closest(STICKY_BTN)
        if (sticky) btn = mainAtc()
      }
    } else if (e.type === 'submit' && t.matches('#MainContent block-buy-buttons form')) {
      btn = t.querySelector('.add-to-cart')
    }
    if (!btn || btn.disabled) return
    var n = tiers().length
    if (!n) return
    var q = qtyValue()
    if (q <= n) return
    e.preventDefault()
    e.stopImmediatePropagation()
    addExact(btn, q, sticky ? stickyVariant(sticky) : null, sticky || btn)
  }

  // ---- 4) riserva: riga Formato + Quantita' --------------------------------------
  function optRow() {
    var meta = document.querySelector('#MainContent .product-single__meta')
    if (!meta) return
    var picker = meta.querySelector(':scope > div:has(> kit-variant-picker)')
    var qty = meta.querySelector(':scope > block-quantity-selector')
    if (!picker && !qty) return
    var row = meta.querySelector(':scope > .cb-opt-row')
    if (!row) {
      row = document.createElement('div')
      row.className = 'cb-opt-row'
      meta.insertBefore(row, picker || qty)
    }
    if (picker && picker.parentElement !== row) row.insertBefore(picker, row.firstChild)
    if (qty && qty.parentElement !== row) row.appendChild(qty)
  }

  // ---- avvio --------------------------------------------------------------------
  var pending = false
  function run() {
    pending = false
    optRow()
    egoThresholds()
    volumeWidth()
  }
  function schedule() {
    if (pending) return
    pending = true
    setTimeout(run, 80)
  }
  function start() {
    run()
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target
        if (t && t.closest && t.closest('.cb-ego-thr')) continue
        schedule()
        return
      }
    }).observe(document.body, { childList: true, subtree: true })
    window.addEventListener('resize', schedule)
    var n = 0
    var iv = setInterval(function () { run(); if (++n > 10) clearInterval(iv) }, 700)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()